/**
 * DevExtreme (esm/common/core/environment/time_zone_utils.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import timeZoneUtils from "../../../__internal/scheduler/m_utils_time_zone";
export const getTimeZones = timeZoneUtils.getTimeZones;